export default {
  id: 'id',
  isAddedByTourOperator: 'isAddedByTourOperator',
  name: 'name',
  attributes: 'attributes',
  note: 'note',
  ssrNumber: 'ssrNumber',
  isLimited: 'isLimited',
  availableCount: 'availableCount',
}
